import React from 'react';

import { CircleFilled, PauseFilled } from '@fluentui/react-icons';

import { AssetContainer } from './types';

export const getAssetContainerNameWithStatus = (assetContainer: AssetContainer, styles: any): any => (
  <span className={styles.assetContainer}>
    <div className={styles.icon}>
      {assetContainer.Status === 'Active' ? <CircleFilled primaryFill="#107C10" /> : <PauseFilled primaryFill="#BEBBB8" />}
    </div>
    <span className={styles.assetContainerText}>{assetContainer.Name}</span>
  </span>
);

